import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Pipe({
    name: 'getSectionForm'
})
export class GetSectionFormPipe implements PipeTransform {
    transform(stepName: string, sectionName: string, workflowFormGroup: FormGroup): FormGroup {
        if (!workflowFormGroup || !stepName || !sectionName) return new FormGroup({});

        return (workflowFormGroup.controls['steps'].get(`step-${stepName}`) as FormGroup).controls['sections'].get(
            `section-${sectionName}`
        ) as FormGroup;
    }
}
